require("core-js/modules/es6.regexp.replace");
var camel2hyphen = function camel2hyphen(str) {
  return str.replace(/[A-Z]/g, function (match) {
    return '-' + match.toLowerCase();
  }).toLowerCase();
};
module.exports = camel2hyphen;